import _defineProperty from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { $transferable } from "./symbols";

function isTransferable(thing) {
  if (!thing || typeof thing !== "object") return false; // Don't check too thoroughly, since the list of transferable things in JS might grow over time

  return true;
}

export function isTransferDescriptor(thing) {
  return thing && typeof thing === "object" && thing[$transferable];
}
export function Transfer(payload, transferables) {
  var _ref;

  if (!transferables) {
    if (!isTransferable(payload)) throw Error();
    transferables = [payload];
  }

  return _ref = {}, _defineProperty(_ref, $transferable, true), _defineProperty(_ref, "send", payload), _defineProperty(_ref, "transferables", transferables), _ref;
}